import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { UserData } from '../../data/system/users';
import { ApiResponse } from '../../data/system/auth';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends UserData {

  constructor(private http: HttpClient) { super(); }

  deleteUser(mem_id: number): any {
    const host = `${env.host}${env.endpoint.users_delete}`;
    return this.http.post<ApiResponse>(host, { mem_id }).pipe(
      tap(data => console.log(`users service -> deleteUser`, data))
    );
  }

  saveUser(userData: any): any {
    const host = `${env.host}${env.endpoint.users_save}`;
    return this.http.post<ApiResponse>(host, userData).pipe(
      tap(data => console.log(`users service -> saveUser`, data))
    );
  }

  getUsersByPagination(page: number, pageSize: number): any {
    const host = `${env.host}${env.endpoint.users_lists}`;
    return this.http.post<ApiResponse>(host, { page: page, per_page: pageSize }).pipe(
      tap(data => console.log(`users service -> getUsersByPagination`, data))
    );
  }

  searchUsers(searchKey: string, page: number, pageSize: number): any {
    const host = `${env.host}${env.endpoint.users_search}`;
    return this.http.post<ApiResponse>(host, { search_key: searchKey, page: page, per_page: pageSize }).pipe(
      tap(data => console.log(`users service -> searchUsers`, data))
    );
  }

  updateUser(userData: any): any {
    const host = `${env.host}${env.endpoint.users_update.replace(':id', userData.mem_id)}`;
    return this.http.post<ApiResponse>(host, userData).pipe(
      tap(data => console.log(`users service -> updateUser`, data))
    );
  }

  getUserJWT(uid: number): any {
    const host = `${env.host}${env.endpoint.users_jwt}`;
    return this.http.post<ApiResponse>(host, { uid }).pipe(
      tap(data => console.log(`users service -> getUserJWT`, data))
    );
  }

}
